import React from "react";
import { BsShareFill } from "react-icons/bs";
import { MdDownload } from "react-icons/md";
import { ShareButton } from "@npm_leadtech/share-button";
import { DownloadButton } from "@npm_leadtech/downloader-button";

import type { QRProps } from "@/contexts/QREditorContext/types";

interface Mp3HeaderProps {
  data: NonNullable<QRProps<"mp3">["data"]>;
  isInitialPreview: boolean;
  hasDownloadButton: boolean;
  hasShareButton: boolean;
}

export const Mp3Header = ({
  data,
  isInitialPreview,
  hasDownloadButton,
  hasShareButton,
}: Mp3HeaderProps) => {
  const renderShareButton = () => {
    if (!hasShareButton) return null;

    if (isInitialPreview) {
      return <BsShareFill style={{ color: data?.themeColor?.buttonColor }} />;
    }

    return (
      <ShareButton
        color={data?.themeColor?.buttonColor}
        icon={<BsShareFill />}
      />
    );
  };

  const renderDownloadButton = () => {
    if (!hasDownloadButton) return null;

    if (isInitialPreview) {
      return (
        <div className="download-button">
          <MdDownload style={{ color: data?.themeColor?.buttonColor }} />
        </div>
      );
    }

    return (
      <DownloadButton
        downloadSource={data?.mp3FileUrl ? [data?.mp3FileUrl] : []}
        disabled={!data?.mp3FileUrl}
        className="download-button"
        customButton={<MdDownload style={{ color: data?.themeColor?.buttonColor }} />}
      />
    );
  };

  return (
    <div className="mp3-template__header">
      {renderDownloadButton()}
      {renderShareButton()}
    </div>
  );
};
